__turbopack_context__.v({
  "backdrop": "_9qAkVW_backdrop",
  "backdropOpen": "_9qAkVW_backdropOpen",
  "navigationButton": "_9qAkVW_navigationButton",
  "root": "_9qAkVW_root",
});
